var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.currentAccount.isAdmin())?_c('admin-dashboard'):_vm._e(),(_vm.currentAccount.isEditor())?_c('editor-dashboard'):_vm._e(),(_vm.currentAccount.isDesigner())?_c('designer-dashboard'):_vm._e(),(_vm.currentAccount.isPhotographer())?_c('artist-dashboard'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }